export interface TourStep {
  id: string;
  targetSelector: string | null;
  /** Dynamic selector built from tour state */
  targetFinder?: (state: { createdClientId: string | null; createdMatterId: string | null }) => string | null;
  message: string;
  subMessage?: string;
  calloutPosition: "top" | "bottom" | "left" | "right";
  /** Route the user must be on for this step */
  requiredPath?: string;
  /** If true, poll for the element to appear (useful after navigation/data loading) */
  waitForElement?: boolean;
  /** For navigation steps: directly navigate to this path instead of clicking the element */
  navigateTo?: string;
  /** Custom padding around the spotlight cutout (default: 10) */
  spotlightPadding?: number;
  // ── Mobile overrides (applied when window.innerWidth < 768) ──
  /** Selector to use on mobile instead of targetSelector */
  mobileTargetSelector?: string | null;
  /** Message to show on mobile instead of message */
  mobileMessage?: string;
  /** Sub-message to show on mobile */
  mobileSubMessage?: string;
  /** Callout position to use on mobile */
  mobileCalloutPosition?: "top" | "bottom" | "left" | "right";
  /** Navigate to this path on mobile when spotlight is tapped */
  mobileNavigateTo?: string;
}

export const TOUR_STEPS: TourStep[] = [
  {
    id: "click-matters",
    // Desktop: spotlight the Matters sidebar nav item
    targetSelector: '[data-tour="nav-matters"]',
    message: "Let's create your first matter and client. Click **Matters** to get started.",
    subMessage: "Don't worry  -  you can delete these later.",
    calloutPosition: "right",
    requiredPath: "/",
    navigateTo: "/matters",
    spotlightPadding: 4,
    // Mobile: spotlight the hamburger button and navigate directly
    mobileTargetSelector: '[data-tour="hamburger-menu"]',
    mobileMessage: "Let's create your first matter and client. Tap the **menu button** to get started.",
    mobileSubMessage: "Don't worry  -  you can delete these later.",
    mobileCalloutPosition: "bottom",
    mobileNavigateTo: "/matters",
  },
  {
    id: "click-new-matter",
    targetSelector: '[data-tour="new-matter-btn"]',
    message: "Click **New Matter** to create your first case.",
    calloutPosition: "bottom",
    requiredPath: "/matters",
    waitForElement: true,
  },
  {
    id: "finish",
    targetSelector: null,
    message: "You're all set! Your matter and client have been created.",
    subMessage: "You can find all your documents organized by client and matter in the Documents section.",
    calloutPosition: "bottom",
  },
];
